import { createContext } from 'react';

const agbaContext = createContext();

export default agbaContext;
